export const AVATAR_SIZE = 24;

export const DISTRIBUTION_URL = 'https://distribution.yandex.ru/';
